import type { CourseModule } from "@/core/types";
import { lektionPlatzhalterErkennen } from "./lektion-01-erkennen";
import { lektionZuruecksetzen } from "./lektion-02-zuruecksetzen";
import { lektionTextfeldRichtig } from "./lektion-03-textfeld-richtig";
import { lektionPlatzhalterAbschluss } from "./lektion-04-abschluss";

export const modulPlatzhalter: CourseModule = {
  id: "platzhalter",
  title: "Platzhalter statt Textfelder",
  summary:
    "Der rote Faden des Kurses: Inhalte gehören in die Platzhalter des Layouts, nicht " +
    "in frei gezogene Kästen – sonst erbt die Folie nichts und muss bei jeder Änderung " +
    "von Hand nachgezogen werden.",
  level: "Grundlagen",
  lessons: [
    lektionPlatzhalterErkennen,
    lektionZuruecksetzen,
    lektionTextfeldRichtig,
    lektionPlatzhalterAbschluss,
  ],
};
